
import { useNavigate } from 'react-router-dom';
import edit from '../../../assets/icons/editnew.svg';
import { useHasPermission } from '../../../Utils/checkPermissions';
export const ActivityCard = ({ activity, onClick }) => {
    const status = activity.status
        ? activity.status.charAt(0).toUpperCase() + activity.status.slice(1).toLowerCase()
        : '-';


    const assignedNames = Array.isArray(activity.employee_list)
        ? activity.employee_list.map(emp => emp.name)
        : [];

    const navigate = useNavigate()
    const handleEditClick = (id) => {
        navigate(`/define-activity/${id}`);
    }

    const hasPermission = useHasPermission();

    return (
        <div
            style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '12px',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
            }}
            className='activity-card item-name-clickable'
            onClick={(e) => onClick(activity.id, activity, e)}
        > <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              
                <h4 style={{ margin: 0, textDecoration: '', fontSize: '15px', fontWeight: '500' }}>{activity.activity_name}</h4>
                {/* <span
                    style={{
                        padding: '4px 10px',
                        borderRadius: '12px',
                        backgroundColor:
                            status.toLowerCase() === 'active' ? '#4caf50' :
                                status.toLowerCase() === 'draft' ? '#f0ad4e' : '#888',
                        color: '#fff',
                        fontSize: '10px',
                        fontWeight: 400,
                    }}
                >
                    {status}
                </span> */}
                {hasPermission('can-create-activity') && (<img src={edit} style={{ cursor: 'pointer' }} alt="Edit"
                    onClick={(e) => {
                        e.stopPropagation();  // ⚡ prevent parent click
                        handleEditClick(activity.id);
                    }}
                    title='Edit Activity' />)}
            </div>
            {activity.description && activity.description !== "N/A" && (
                <p style={{ fontSize: '13px' }}>{activity.description}</p>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span
                    style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: '#7F56DA',
                    }}
                ></span>
                <span style={{ fontSize: '13px', }} >
                    {activity.total_students
                        ? `${activity.completed_students || 0} / ${activity.total_students || 0} cards issued`
                        : '0 / 0 cards issued'}
                </span>
            </div>
            <p style={{ fontSize: "13px" }}>
                <strong>Activity Type:</strong>{" "}
                {activity.academic_event_type?.name}
            </p>
            {activity.academic_event_type?.name?.includes("Practical") && (
                <p style={{ fontSize: "13px" }}>
                    <strong>Practical Subject:</strong>{" "}
                  <span style={{ color: "#f97316" }}>{activity.practical_subject}</span>
                </p>
            )}
            <p style={{ fontSize: "13px" }}>
                <strong>Assign to:</strong>{" "}
                {assignedNames.length > 0 ? assignedNames.join(", ") : "-"}
            </p>
            <p style={{ fontSize: "13px" }}>
                <strong>Created By:</strong>{" "}
                {activity.created_by}
            </p>

            <p style={{ fontSize: '13px', }} >{formatDateSmart({ start: activity.start_date, end: activity.end_date })}</p>
            {activity?.exam_start_date && (<p style={{ fontSize: '13px', }} title='Exam Start Date'> <strong>Exam Date:</strong> {formatDateSmart(activity.exam_start_date)}</p>)}

        </div>
    );
};
const formatDateSmart = (timeline) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };

    const calcRemaining = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        const diff = Math.round((date - today) / (1000 * 60 * 60 * 24));

        if (diff > 0) return { text: `${diff} days to go`, diff };
        if (diff === 0) return { text: "Today", diff: 0 };
        return { text: `${Math.abs(diff)} days ago`, diff };
    };

    // Exam date → string
    if (typeof timeline === "string") {
        const d = new Date(timeline);
        const formatted = d.toLocaleDateString("en-GB", options);
        const remaining = calcRemaining(d);

        // JSX with color styling based on remaining days
        return (
            <span>
                {formatted}{" "}
                <span
                    style={{
                        color:
                            remaining.diff <= 3
                                ? "red"
                                : remaining.diff <= 7
                                    ? "orange"
                                    : "green",
                        fontWeight: "bold",
                    }}
                >
                    ({remaining.text})
                </span>
            </span>
        );
    }

    // Activity timeline → just show range
    if (timeline?.start && timeline?.end) {
        const start = new Date(timeline.start).toLocaleDateString("en-GB", options);
        const end = new Date(timeline.end).toLocaleDateString("en-GB", options);
        return `${start} – ${end}`;
    }

    return "-";
};
